import{get as e}from"lodash";function t(t,n,r){return e(t,n)||r}export{t as getValueOrFallback};
//# sourceMappingURL=get-value-or-fallback.js.map